/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AlignItemsMiddle({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#AlignItemsMiddle_svg__a)" clipRule="evenodd"><path d="M7.1 13V3A2.1 2.1 0 0 0 5 .9H3A2.1 2.1 0 0 0 .9 3v10c0 1.16.94 2.1 2.1 2.1h2A2.1 2.1 0 0 0 7.1 13M5.9 3v10a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9V3a.9.9 0 0 1 .9-.9h2a.9.9 0 0 1 .9.9M15.1 10.5v-5A2.1 2.1 0 0 0 13 3.4h-2a2.1 2.1 0 0 0-2.1 2.1v5c0 1.16.94 2.1 2.1 2.1h2a2.1 2.1 0 0 0 2.1-2.1m-1.2-5v5a.9.9 0 0 1-.9.9h-2a.9.9 0 0 1-.9-.9v-5a.9.9 0 0 1 .9-.9h2a.9.9 0 0 1 .9.9" /></g><defs><clipPath id="AlignItemsMiddle_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;